import { RagFaqPlatform } from "@prisma/client";
import { z } from "zod";

export const upsertChatboxQuestionSchema = z.object({
  question: z.string().min(1),
  answer: z.string().min(1).max(1500),
  platform: z.array(z.nativeEnum(RagFaqPlatform)).min(1),
});

export type UpsertChatboxQuestionForm = z.infer<
  typeof upsertChatboxQuestionSchema
>;

export const defaultUpsertChatboxQuestionValues: UpsertChatboxQuestionForm = {
  question: "",
  answer: "",
  platform: [],
};
